{
    "accepted_file": "Accepted file:",
    "authentication_settings": "Authentication Settings",
    "cancel": "Cancel",
    "claim_details": "Claim details",
    "clear": "Clear",
    "clear_document_search": "Clear document search",
    "close": "Close",
    "document_opened_at_the_first_available_page": "Document opened at the first available page.",
    "download": "Download",
    "download_pdf": "Download PDF",
    "drop_file_hint": "Drag and drop a file here, or click to select a file",
    "failed_to_load_pdf": "Failed to load PDF",
    "hide_navigation": "Hide navigation",
    "home": "Home",
    "loading": "Loading",
    "loading_organizations": "Loading organizations",
    "loading_pdf": "Loading PDF...",
    "log_out": "Log out",
    "match_position": "{{current}} of {{total}}",
    "member_management": "Member Management",
    "more_selected": "+ {{number}} more",
    "navigation": "Navigation",
    "next_matching_page": "Next matching page",
    "no_matches": "No matches",
    "no_other_organizations": "No other organizations",
    "no_results": "No results found.",
    "open_in_new_tab": "Open in New Tab",
    "opened_page": "Document opened on page {{page}}.",
    "pdf_document_viewer": "PDF document viewer",
    "pdf_load_error": "There was an error loading the PDF document.",
    "pdf_preview_not_available": "PDF Preview Not Available",
    "pdf_unsupported": "Your browser does not support PDF previews. You can download or open the document in a new tab.",
    "platform": "Platform",
    "previous_matching_page": "Previous matching page",
    "route_names": {
        "claims": "claims",
        "new": "new",
        "settings": "settings"
    },
    "search_document_text": "Search document text",
    "search_document_text_2": "Search document text...",
    "select_all": "(Select All)",
    "select_options": "Select options",
    "select_search": "Search...",
    "settings": "Settings",
    "show_navigation": "Show navigation",
    "switch_organization": "Switch organization",
    "toggle_sidebar": "Toggle Sidebar",
    "unable_to_load_try_again": "Unable to load. Try again"
}
